'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
var slicedToArray = require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var components_Icon_Icon = require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');
require('../../utils/ref/refType.js');
var withIntlAriaAttrs = require('../../withIntlAriaAttrs-d3af74a8.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var styleVariantMapStyle = {
  primary: {
    contained: {
      styles: styled.css(["background:", ";color:", ";--rippleLayerColor:", ";"], styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('white', 'defaultT20')),
      hoverLayerColor: styles_themeUtils.nuDSColor('white', 'defaultT10'),
      actionLayerColor: styles_themeUtils.nuDSColor('white', 'defaultT20')
    },
    basic: {
      styles: styled.css(["background:transparent;color:", ";--rippleLayerColor:", ";"], styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('primary', 'defaultL40')),
      hoverLayerColor: styles_themeUtils.nuDSColor('primary', 'defaultL10'),
      actionLayerColor: styles_themeUtils.nuDSColor('primary', 'defaultL20')
    }
  },
  black: {
    contained: {
      styles: styled.css(["background:", ";color:", ";--rippleLayerColor:", ";"], styles_themeUtils.nuDSColor('black'), styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('white', 'defaultT20')),
      hoverLayerColor: styles_themeUtils.nuDSColor('white', 'defaultT10'),
      actionLayerColor: styles_themeUtils.nuDSColor('white', 'defaultT20')
    },
    basic: {
      styles: styled.css(["background:transparent;color:", ";--rippleLayerColor:", ";"], styles_themeUtils.nuDSColor('black'), styles_themeUtils.nuDSColor('primary', 'defaultL40')),
      hoverLayerColor: styles_themeUtils.nuDSColor('primary', 'defaultL10'),
      actionLayerColor: styles_themeUtils.nuDSColor('primary', 'defaultL20')
    }
  },
  white: {
    contained: {
      styles: styled.css(["background:", ";color:", ";--rippleLayerColor:", ";"], styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('primary', 'defaultL40')),
      hoverLayerColor: styles_themeUtils.nuDSColor('primary', 'defaultL10'),
      actionLayerColor: styles_themeUtils.nuDSColor('primary', 'defaultL20')
    },
    basic: {
      styles: styled.css(["background:transparent;color:", ";--rippleLayerColor:", ";"], styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('white', 'defaultT20')),
      hoverLayerColor: styles_themeUtils.nuDSColor('white', 'defaultT10'),
      actionLayerColor: styles_themeUtils.nuDSColor('white', 'defaultT20'),
      disabled: styled.css(["color:", ";"], styles_themeUtils.nuDSColor('white', 'defaultT20'))
    }
  }
};
var statesVariantMapStyle = {
  disabled: {
    "default": styled.css(["cursor:not-allowed;", ";"], function (_ref) {
      var styleVariant = _ref.styleVariant,
          variant = _ref.variant;
      return styleVariantMapStyle[styleVariant][variant].disabled;
    }),
    basic: styled.css(["color:", ";background:transparent;"], styles_themeUtils.nuDSColor('black', 'defaultT20')),
    contained: styled.css(["color:", ";background:", ";"], styles_themeUtils.nuDSColor('black', 'defaultT20'), styles_themeUtils.nuDSColor('black', 'defaultT10'))
  },
  hover: styled.css([":before{background:", ";}"], function (_ref2) {
    var styleVariant = _ref2.styleVariant,
        variant = _ref2.variant;
    return styleVariantMapStyle[styleVariant][variant].hoverLayerColor;
  }),
  active: styled.css([":before{background:", ";}"], function (_ref3) {
    var styleVariant = _ref3.styleVariant,
        variant = _ref3.variant;
    return styleVariantMapStyle[styleVariant][variant].actionLayerColor;
  })
};
var variantMapStyle = {
  contained: styled.css(["padding-left:1.25rem;padding-right:1.25rem;border-radius:6.25rem;"]),
  basic: styled.css(["padding-left:1.25rem;padding-right:1.25rem;border-radius:6.25rem;"]),
  iconOnly: styled.css(["justify-content:center;border-radius:100%;width:3rem;height:3rem;"])
};
var displayMapStyle = {
  extended: styled.css(["display:flex;width:100%;margin-bottom:1rem;justify-content:", ";"], function (_ref4) {
    var hasIcon = _ref4.hasIcon;
    return hasIcon ? 'space-between' : 'center';
  }),
  inline: styled.css(["display:inline-flex;"])
};
var sizeMapStyle = {
  "default": styled.css(["height:3rem;"]),
  small: styled.css(["height:2rem;"])
};
var BaseButton = styled__default['default'].button.withConfig({
  displayName: "BaseButton",
  componentId: "sc-1qgrxnb-0"
})(["", ";", ";", ";", ";cursor:pointer;outline:0;align-items:center;vertical-align:middle;overflow:hidden;position:relative;border:0;transform:translate3d(0,0,0);& > svg{margin-left:", ";}span,svg{position:relative;z-index:2;}svg,div,:after,:before{pointer-events:none;}:before{content:\"\";display:block;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;transition:350ms linear;}:disabled{", ";", ";}:hover:not(:disabled){", ";}:active:not(:disabled),:focus:not(:disabled){", ";}"], function (_ref5) {
  var variant = _ref5.variant,
      isIconOnly = _ref5.isIconOnly;
  return isIconOnly ? variantMapStyle.iconOnly : variantMapStyle[variant];
}, function (_ref6) {
  var styleVariant = _ref6.styleVariant,
      variant = _ref6.variant;
  return styleVariantMapStyle[styleVariant][variant].styles;
}, function (_ref7) {
  var size = _ref7.size;
  return sizeMapStyle[size];
}, function (_ref8) {
  var extended = _ref8.extended;
  return extended ? displayMapStyle.extended : displayMapStyle.inline;
}, function (_ref9) {
  var hasText = _ref9.hasText;
  return hasText ? '0.5rem' : '0';
}, function (_ref10) {
  var variant = _ref10.variant;
  return statesVariantMapStyle.disabled[variant];
}, statesVariantMapStyle.disabled["default"], statesVariantMapStyle.hover, statesVariantMapStyle.active);
BaseButton.displayName = 'BaseButton';
BaseButton.propTypes = {
  extended: index.propTypes.bool.isRequired,
  size: index.propTypes.oneOf(Object.keys(sizeMapStyle)).isRequired,
  styleVariant: index.propTypes.oneOf([].concat(styles_breakpoints.toConsumableArray(Object.keys(styleVariantMapStyle)), [''])).isRequired,
  variant: index.propTypes.oneOf(Object.keys(variantMapStyle)).isRequired
};

var waveRippleAnimation = styled.keyframes(["0%{transform:scale(0);opacity:0;}50%{opacity:1;}100%{opacity:0;transform:scale(var(--scale));}"]);
var WaveBase = styled__default['default'].div.withConfig({
  displayName: "WaveBase",
  componentId: "sc-7eh6wx-0"
})(["--scale:", ";width:.3125rem;height:.3125rem;position:absolute;top:calc(", "px - .3125rem);left:calc(", "px - .3125rem);border-radius:inherit;&:after{content:\"\";display:block;border-radius:inherit;width:.625rem;height:.625rem;background:var(--rippleLayerColor);will-change:transform,opacity;transform:scale(0);opacity:0;animation:", " 500ms;}"], function (_ref) {
  var scale = _ref.scale;
  return scale;
}, function (_ref2) {
  var top = _ref2.top;
  return top;
}, function (_ref3) {
  var left = _ref3.left;
  return left;
}, waveRippleAnimation);
WaveBase.displayName = 'Wave';
WaveBase.propTypes = {
  left: index.propTypes.number.isRequired,
  scale: index.propTypes.number.isRequired,
  top: index.propTypes.number.isRequired
};

function Wave(_ref) {
  var id = _ref.id,
      removeWaveById = _ref.removeWaveById,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["id", "removeWaveById"]);

  function handleAnimationEnd() {
    removeWaveById(id);
  }

  return /*#__PURE__*/React__default['default'].createElement(WaveBase, _extends._extends_1({}, props, {
    onAnimationEnd: handleAnimationEnd
  }));
}
Wave.propTypes = _extends._extends_1({
  id: index.propTypes.number.isRequired,
  removeWaveById: index.propTypes.func.isRequired
}, WaveBase.propTypes);

function useRipple() {
  var _useState = React.useState([]),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      waves = _useState2[0],
      setWaves = _useState2[1];

  function addWave(_ref, idGenerator) {
    var _ref$topPosition = _ref.topPosition,
        topPosition = _ref$topPosition === void 0 ? 0 : _ref$topPosition,
        _ref$bottomPosition = _ref.bottomPosition,
        bottomPosition = _ref$bottomPosition === void 0 ? 0 : _ref$bottomPosition,
        _ref$leftPosition = _ref.leftPosition,
        leftPosition = _ref$leftPosition === void 0 ? 0 : _ref$leftPosition,
        _ref$rightPosition = _ref.rightPosition,
        rightPosition = _ref$rightPosition === void 0 ? 0 : _ref$rightPosition;
    var waveDiameter = Math.max(topPosition, bottomPosition, leftPosition, rightPosition) * 2;
    var scaleValue = waveDiameter / 10;
    var newWave = {
      id: idGenerator(),
      top: topPosition,
      left: leftPosition,
      scale: scaleValue
    };
    setWaves([].concat(styles_breakpoints.toConsumableArray(waves), [newWave]));
  }

  function removeWaveById(currentWaveId) {
    setWaves(waves.filter(function (wave) {
      return wave.id !== currentWaveId;
    }));
  }

  function addRippleEffectWave(_ref2) {
    var _ref2$startFromMiddle = _ref2.startFromMiddle,
        startFromMiddle = _ref2$startFromMiddle === void 0 ? false : _ref2$startFromMiddle,
        baseElementBoundingClientRect = _ref2.baseElementBoundingClientRect,
        _ref2$mousePosition = _ref2.mousePosition,
        mousePosition = _ref2$mousePosition === void 0 ? {
      clientX: 0,
      clientY: 0
    } : _ref2$mousePosition,
        _ref2$idGenerator = _ref2.idGenerator,
        idGenerator = _ref2$idGenerator === void 0 ? Date.now : _ref2$idGenerator;
    var width = baseElementBoundingClientRect.width,
        height = baseElementBoundingClientRect.height,
        baseTop = baseElementBoundingClientRect.top,
        baseLeft = baseElementBoundingClientRect.left,
        baseRight = baseElementBoundingClientRect.right,
        baseBottom = baseElementBoundingClientRect.bottom;

    if (startFromMiddle) {
      var _topPosition = height / 2;

      var _leftPosition = width / 2;

      addWave({
        topPosition: _topPosition,
        leftPosition: _leftPosition
      }, idGenerator);
      return;
    }

    var clientX = mousePosition.clientX,
        clientY = mousePosition.clientY;
    var topPosition = Math.abs(baseTop - clientY);
    var bottomPosition = Math.abs(clientY - baseBottom);
    var leftPosition = Math.abs(baseLeft - clientX);
    var rightPosition = Math.abs(clientX - baseRight);
    addWave({
      topPosition: topPosition,
      bottomPosition: bottomPosition,
      leftPosition: leftPosition,
      rightPosition: rightPosition
    }, idGenerator);
  }

  return {
    waves: waves,
    setWaves: setWaves,
    addRippleEffectWave: addRippleEffectWave,
    removeWaveById: removeWaveById
  };
}

var ENTER_KEY_CODE = 13;
var SPACEBAR_KEY_CODE = 32;
var keyCodesAllowedSet = new Set([ENTER_KEY_CODE, SPACEBAR_KEY_CODE]);
var typographyVariant = {
  "default": 'action',
  small: 'text2'
};

function executeRippleEffect(_ref, addRippleEffectWaveFn) {
  var _ref$startFromMiddle = _ref.startFromMiddle,
      startFromMiddle = _ref$startFromMiddle === void 0 ? false : _ref$startFromMiddle,
      target = _ref.target,
      clientX = _ref.clientX,
      clientY = _ref.clientY;
  var buttonPosition = target.getBoundingClientRect();
  addRippleEffectWaveFn({
    startFromMiddle: startFromMiddle,
    baseElementBoundingClientRect: buttonPosition,
    mousePosition: {
      clientX: clientX,
      clientY: clientY
    }
  });
}

var Button = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var type = _ref2.type,
      children = _ref2.children,
      styleVariant = _ref2.styleVariant,
      extended = _ref2.extended,
      size = _ref2.size,
      iconProps = _ref2.iconProps,
      variant = _ref2.variant,
      typographyProps = _ref2.typographyProps,
      disabled = _ref2.disabled,
      intlKey = _ref2.intlKey,
      onClick = _ref2.onClick,
      props = objectWithoutProperties.objectWithoutProperties(_ref2, ["type", "children", "styleVariant", "extended", "size", "iconProps", "variant", "typographyProps", "disabled", "intlKey", "onClick"]);

  var _useRipple = useRipple(),
      addRippleEffectWave = _useRipple.addRippleEffectWave,
      removeWaveById = _useRipple.removeWaveById,
      waves = _useRipple.waves;

  var hasIcon = Boolean(iconProps);
  var hasText = Boolean(children) || intlKey || Boolean(typographyProps);
  var isIconOnly = hasIcon && !hasText;

  var handleOnMouseDown = function handleOnMouseDown(event) {
    executeRippleEffect({
      target: event.currentTarget,
      clientX: event.clientX,
      clientY: event.clientY
    }, addRippleEffectWave);
  };

  var handleKeydown = function handleKeydown(event) {
    if (keyCodesAllowedSet.has(event.keyCode)) {
      executeRippleEffect({
        startFromMiddle: true,
        target: event.target
      }, addRippleEffectWave);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(BaseButton, _extends._extends_1({
    ref: ref,
    type: type,
    variant: variant,
    styleVariant: styleVariant,
    extended: extended,
    size: size,
    isIconOnly: isIconOnly,
    hasText: hasText,
    hasIcon: hasIcon,
    disabled: disabled,
    onClick: onClick,
    onMouseDown: handleOnMouseDown,
    onKeyDown: handleKeydown
  }, props), hasText && /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], _extends._extends_1({}, typographyProps, {
    variant: typographyVariant[size],
    tag: "span",
    intlKey: intlKey
  }), children), hasIcon && /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, _extends._extends_1({
    "aria-hidden": hasText
  }, iconProps, {
    size: "small"
  })), waves.map(function (currentWave) {
    return /*#__PURE__*/React__default['default'].createElement(Wave, {
      key: currentWave.id,
      id: currentWave.id,
      top: currentWave.top,
      left: currentWave.left,
      scale: currentWave.scale,
      removeWaveById: removeWaveById
    });
  }));
});
Button.defaultProps = {
  extended: false,
  type: 'button',
  size: 'default',
  styleVariant: 'primary',
  onClick: undefined,
  variant: 'contained',
  typographyProps: null,
  iconProps: null,
  disabled: false,
  intlKey: '',
  children: null
};
Button.propTypes = {
  /** The content of the component, it can be either another component or raw text */
  children: index.propTypes.node,

  /** Defines if the button is disabled or not */
  disabled: index.propTypes.bool,

  /** Defines is the button will have the full width of the parent component */
  extended: index.propTypes.bool,

  /** The props of the Icon component, check it to see the available props. */
  iconProps: index.propTypes.shape(_extends._extends_1({}, components_Icon_Icon.Icon.propTypes)),

  /** An i18n key that will be used to search for content */
  intlKey: index.propTypes.string,

  /** A function that will be called when the button receives a click */
  onClick: index.propTypes.func,

  /** Defines the size of the button */
  size: index.propTypes.oneOf(['default', 'small']),

  /** The visual style that works combined with the chosen variant */
  styleVariant: index.propTypes.oneOf(['primary', 'black', 'white']),

  /** The type of the button */
  type: index.propTypes.oneOf(['button', 'submit', 'reset']),

  /** The props of the Typography component, check it to see the available props. */
  typographyProps: index.propTypes.shape(_extends._extends_1({}, components_Typography_Typography['default'].propTypes)),

  /** The base style of the component */
  variant: index.propTypes.oneOf(['contained', 'basic'])
};
var Button$1 = withIntlAriaAttrs.withIntlAriaAttrs(Button);

exports.default = Button$1;
//# sourceMappingURL=Button.js.map
